'use client';
import NextImage, { ImageProps } from 'next/legacy/image';
import ErrorBoundary from '../ErrorBoundary';
import imageLoader from '../../utils/imageLoader';

export const Image = (props: ImageProps) => {
  const src = props.src as string;
  const isAmplienceImage =
    src?.startsWith?.('https://i8.amplience.net') ||
    src?.startsWith?.('https://cdn.media.amplience.net');
  return (
    <ErrorBoundary>
      <NextImage {...props} loader={isAmplienceImage ? imageLoader : undefined} />
    </ErrorBoundary>
  );
};

export default Image;
